import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, TextField, DialogActions, Button, Box } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useStoreState, useStoreActions } from 'easy-peasy';
import { paymentMethods } from 'constants/paymentMethods';

import MaterialSelect from './Select';
import authFetch from '../api/Authorization';

const paymentType = paymentMethods.map((type) => ({
  value: type,
  name: <FormattedMessage id={`payment_type.${type}`} />,
}));

const AddPatientModal = ({ open = false, handleClose, onSuccess }) => {
  const [loading, setLoading] = useState(false);

  const submitValues = async (values, formContext) => {
    try {
      setLoading(true);
      const response = await authFetch.signUp(localStorage.getItem('accessToken'), values);
      setLoading(false);
      if (!response.error) {
        onSuccess(response);
        formContext.resetForm();
        handleClose();
      } else if (response.error.data === 'User already exists') {
        formContext.setFieldError('email', 'error.user_already_exists');
      }
    } catch (err) {
      setLoading(false);
    }
  };

  const { values, handleChange, handleSubmit, resetForm, errors, touched } = useFormik({
    initialValues: {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      type: 'patient',
      paymentType: '',
    },
    validationSchema: Yup.object({
      firstName: Yup.string().required(),
      lastName: Yup.string().required(),
      email: Yup.string().email(),
      phone: Yup.string().required(),
      type: Yup.string().equals(['patient']),
      paymentType: Yup.string().equals(['self_pay', 'social_security', 'insurance', 'coex']).required(),
    }),
    onSubmit: submitValues,
  });

  const clearAndClose = () => {
    resetForm();
    handleClose();
  };

  return (
    <Dialog open={open} onClose={clearAndClose}>
      <DialogTitle>
        <FormattedMessage id="patient_modal.add_new_patient" />
      </DialogTitle>
      <DialogContent>
        <Box display="flex" flexWrap="wrap" justifyContent="space-between">
          <TextField
            onChange={handleChange}
            fullWidth
            name="firstName"
            error={touched.firstName && errors.firstName}
            value={values.firstName}
            label={<FormattedMessage id="user.first_name" />}
            variant="outlined"
          />
          <TextField
            fullWidth
            style={{ marginTop: '20px' }}
            onChange={handleChange}
            value={values.lastName}
            error={touched.lastName && errors.lastName}
            name="lastName"
            variant="outlined"
            label={<FormattedMessage id="user.last_name" />}
          />
        </Box>
        <Box marginY="20px">
          <TextField
            onChange={handleChange}
            fullWidth
            error={touched.email && errors.email}
            helperText={touched.email && errors.email && <FormattedMessage id={errors.email} />}
            name="email"
            value={values.email}
            variant="outlined"
            label={<FormattedMessage id="user.email_adress" />}
          />
          <TextField
            style={{ marginTop: '20px' }}
            onChange={handleChange}
            fullWidth
            type="number"
            name="phone"
            error={touched.phone && errors.phone}
            value={values.phone}
            variant="outlined"
            label={<FormattedMessage id="user.phone" />}
          />
        </Box>
        <MaterialSelect
          style={{ marginBottom: '20px' }}
          options={paymentType}
          onChange={handleChange}
          value={values.paymentType}
          error={touched.paymentType && errors.paymentType}
          name="paymentType"
          variant="outlined"
          title={<FormattedMessage id="user.payment_type" />}
        />
      </DialogContent>
      <DialogActions>
        <Button disabled={loading} onClick={clearAndClose} color="secondary">
          <FormattedMessage id="services.cancel" />
        </Button>
        <Button disabled={loading} color="primary" onClick={handleSubmit}>
          <FormattedMessage id="services.add" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddPatientModal;
